module.exports = __webpack_public_path__ + "static/3-Tri-03-a673f00843fadf3e3c37cae33848bced.png";